import React, { useCallback } from 'react';

import { FormContainerProps } from '@occc-app/offerHelpers/types';
import { useGetConfigureFormProps } from '@occc-app/offerHelpers/hooks/useGetConfigureFormProps';
import { useGetProductGroupsForOffer } from '@occc-app/dataAccessLayer/productGroup/queries';

import { ConfigureForm } from './ConfigureForm';
import { SweepstakesConfigureFormInitialValues, SweepstakesConfigureFormValues } from './types';
import { transformToInitialValues } from './utils';
import { getConfigureFormOperations } from './getConfigureFormOperations';

export const SweepstakesConfigureFormContainer: React.FC<FormContainerProps> = (props) => {
  const { offer } = props;
  const productGroups = useGetProductGroupsForOffer(offer);
  const transformToInitialValuesWithProductGroups = useCallback(
    (currentOffer: Parameters<typeof transformToInitialValues>[0]) =>
      transformToInitialValues(currentOffer, productGroups),
    [productGroups],
  );

  const configureProps = useGetConfigureFormProps<
    SweepstakesConfigureFormValues,
    SweepstakesConfigureFormInitialValues
  >(props, transformToInitialValuesWithProductGroups, getConfigureFormOperations);

  return <ConfigureForm {...configureProps} />;
};
